module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/step_01.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fstep_01.jpg
// module id = Ur/Y
// module chunks = 93